<template>
  <div class="row">
    <div class="col-lg-12 col-md-12">
      <card class="shadow-lg">
        <div class="row content-add-btn">
          <button class="btn btn-secondary" @click="$router.go(-1)">
            <em class="fa fa-chevron-left"></em>
            {{ $t('common_words.exit') }}
          </button>
        </div>
        <hr />
        <form-wizard
          ref="formWizard"
          v-if="this.isCreate() || this.isUpdate()"
          @on-complete="storeUpdateBusiness"
          title
          subtitle
          :back-button-text="$t('common_words.back')"
          :next-button-text="$t('common_words.next')"
          :finish-button-text="$t('common_words.save')"
          class="custom-padding-wz-header"
        >
          <tab-content
            :title="$t('common_words.general_information')"
            :before-change="() => validateStep('firstStep')"
          >
            <first-step
              ref="firstStep"
              @on-validated="onStepValidated"
              @fillBusinessForm="fillBusinessForm"
              @showHideLoading="showHideLoading"
            ></first-step>
          </tab-content>

          <tab-content
            :title="$t('common_words.ubication')"
            :before-change="() => validateStep('secondStep')"
          >
            <second-step
              ref="secondStep"
              @on-validated="onStepValidated"
              @fillBusinessForm="fillBusinessForm"
              @showHideLoading="showHideLoading"
            ></second-step>
          </tab-content>

          <tab-content
            :title="$t('common_words.contacts')"
            :before-change="() => validateStep('thirdStep')"
          >
            <third-step
              ref="thirdStep"
              @on-validated="onStepValidated"
              @fillBusinessForm="fillBusinessForm"
              @showHideLoading="showHideLoading"
            ></third-step>
          </tab-content>

          <tab-content
            :title="$t('common_words.area2')"
            :before-change="() => validateStep('fourthStep')"
          >
            <fourth-step
              ref="fourthStep"
              @on-validated="onStepValidated"
              @fillBusinessForm="fillBusinessForm"
              @showHideLoading="showHideLoading"
            ></fourth-step>
          </tab-content>

          <tab-content
            :title="$t('common_words.module')"
            :before-change="() => validateStep('fifthStep')"
          >
            <fifth-step
              ref="fifthStep"
              @on-validated="onStepValidated"
              @fillBusinessForm="fillBusinessForm"
              @showHideLoading="showHideLoading"
            ></fifth-step>
          </tab-content>

          <tab-content
            :title="$t('common_words.associated_clime_api')"
            :before-change="() => validateStep('sixthStep')"
          >
            <sixth-step
              ref="sixthStep"
              @on-validated="onStepValidated"
              @fillBusinessForm="fillBusinessForm"
              @showHideLoading="showHideLoading"
            ></sixth-step>
          </tab-content>

          <tab-content :title="$t('common_words.confirm')">
            <p class="cm-mg-p-wzd text-center text-muted">
              {{ $t('common_words.verify_inputed_information') }}
            </p>
            <br />
            <div class="row d-flex justify-content-center">
              <div class="col-8">
                <table class="table">
                  <tbody>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.nit') }}:</strong>
                        </h6>
                        {{ businessForm.nit }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.sub_center') }}:</strong>
                        </h6>
                        {{
                          businessForm.sub_center
                            ? businessForm.sub_center
                            : $t('common_words.no_assigned')
                        }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.group') }}:</strong>
                        </h6>
                        {{
                          businessForm.group
                            ? businessForm.group
                            : $t('common_words.no_assigned')
                        }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.code') }}:</strong>
                        </h6>
                        {{
                          businessForm.code
                            ? businessForm.code
                            : $t('common_words.no_assigned')
                        }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.cost_center') }}:</strong>
                        </h6>
                        {{
                          businessForm.cost_center
                            ? businessForm.cost_center
                            : $t('common_words.no_assigned')
                        }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong
                            >{{ $t('common_words.comercial_name') }}:</strong
                          >
                        </h6>
                        {{
                          businessForm.tradename
                            ? businessForm.tradename
                            : $t('common_words.no_assigned')
                        }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong
                            >{{
                              $t('common_words.types_of_companies')
                            }}:</strong
                          >
                        </h6>
                        <br />
                        <span
                          v-for="(type, index) in businessForm.types_names"
                          :key="index"
                        >
                          <el-tag type="info">{{ type }}</el-tag>
                        </span>
                      </td>
                    </tr>
                    <tr
                      class="shadow-sm"
                      v-if="businessForm.groups_names.length > 0"
                    >
                      <td>
                        <h6>
                          <strong
                            >{{ $t('common_words.group_companies2') }}:</strong
                          >
                        </h6>
                        <br />
                        <span
                          v-for="(name, index) in businessForm.groups_names"
                          :key="index"
                        >
                          <el-tag type="info">{{ name }}</el-tag>
                        </span>
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong
                            >{{
                              $t('common_words.comercial_activities')
                            }}:</strong
                          >
                        </h6>
                        {{ businessForm.comercial_activity }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.guild2') }}:</strong>
                        </h6>
                        {{ businessForm.about_you }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.address') }}:</strong>
                        </h6>
                        {{ businessForm.city }} , {{ businessForm.state }} -
                        {{ businessForm.country }}; {{ businessForm.address }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.phone') }}:</strong>
                        </h6>
                        {{ businessForm.phone }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.email') }}:</strong>
                        </h6>
                        {{ businessForm.email }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.website') }}:</strong>
                        </h6>
                        {{ businessForm.web_site }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong
                            >{{
                              $t('common_words.associated_clime_api')
                            }}:</strong
                          >
                        </h6>
                        <br />
                        <span
                          v-for="(mark, index) in businessForm.station_mark"
                          :key="index"
                        >
                          <el-tag type="info">{{ mark }}</el-tag>
                        </span>
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.contacts') }}:</strong>
                        </h6>
                        <br />
                        <span
                          v-for="(contact, index) in businessForm.contact_names"
                          :key="index"
                        >
                          <el-tag type="info" v-if="contact.length != 0"
                            >{{ $t('common_words.name') }}: {{ contact }} -
                            {{ $t('common_words.position') }}:
                            {{ businessForm.contact_positions[index] }} - Tel:
                            {{ businessForm.contact_phones[index] }}</el-tag
                          >
                          <br v-if="index % 5 == 0 && index != 0" />
                        </span>
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.area2') }}:</strong>
                        </h6>
                        <br />
                        <span
                          v-for="(area, index) in businessForm.areas_names"
                          :key="index"
                        >
                          <el-tag type="info">{{ area }}</el-tag>
                          <br v-if="index % 5 == 0 && index != 0" />
                        </span>
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.modules') }}:</strong>
                        </h6>
                        <br />
                        <span
                          v-for="(mod, index) in businessForm.modules_names"
                          :key="index"
                        >
                          <el-tag type="info">{{ mod }}</el-tag>
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </tab-content>
        </form-wizard>
        <div v-else>
          <br />
          <h5 class="text-muted text-center">
            {{ $t('common_words.no_permissions_operations') }}
          </h5>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { showContinue } from 'src/util/Util.js';
import FifthStep from './steps/FifthStep.vue';
import FirstStep from './steps/FirstStep.vue';
import FourthStep from './steps/FourthStep.vue';
import MixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import SecondStep from './steps/SecondStep.vue';
import SixthStep from './steps/SixthStep.vue';
import ThirdStep from './steps/ThirdStep.vue';

export default {
  components: {
    FirstStep,
    SecondStep,
    ThirdStep,
    FourthStep,
    FifthStep,
    SixthStep,
  },
  data() {
    return {
      title: '',
      businessForm: {
        name: null,
        address: null,
        groups_names: [],
      },
      wizardModel: {},
    };
  },

  mixins: [MixinPermissions, MixinMasters, MixinMenu],

  methods: {
    cleanAllSteps() {
      this.$refs.firstStep.model = {
        type_ids: [],
        businesses_ids: [],
      };
      this.$refs.secondStep.model = {
        address: null,
        country: null,
        city: null,
        state: null,
      };
      this.$refs.thirdStep.model = {
        contact_names: [],
        contact_phones: [],
        contact_positions: [],
      };
      this.$refs.fourthStep.model = {
        areas_names: [],
        areas_ids: [],
      };
      this.$refs.fifthStep.model = {
        modules_names: [],
        modules_ids: [],
      };
      this.$refs.sixthStep.model = {
        nKeys: 1,
        station_marks: [],
        private_key: [],
        public_key: [],
      };
      this.businessForm = {
        name: null,
        address: null,
        groups_names: [],
      };
    },

    validateStep(ref) {
      return this.$refs[ref].validate();
    },

    onStepValidated(validated, model) {
      this.wizardModel = { ...this.wizardModel, ...model };
    },

    fillBusinessForm(ref, others) {
      this.businessForm = Object.assign(
        {},
        this.businessForm,
        this.$refs[ref].model
      );
      if (others)
        this.businessForm = Object.assign({}, this.businessForm, others);
    },

    storeUpdateBusiness() {
      this.showHideLoading(true);
      this.businessForm.route = 'businesses';
      if (sessionStorage.getItem('editForm')) {
        if (this.isUpdate()) {
          this.businessForm.id = JSON.parse(
            sessionStorage.getItem('editForm')
          ).id;

          if (
            this.$refs.firstStep.model.icon &&
            this.$refs.firstStep.model.fileList.length === 0 &&
            this.$refs.firstStep.fileList.length === 0
          ) {
            this.businessForm.icon = null;
          } else if (
            this.$refs.firstStep.model.icon &&
            (!this.$refs.firstStep.model.fileList ||
              this.$refs.firstStep.model.fileList.length > 0)
          ) {
            this.businessForm.icon = this.$refs.firstStep.model.icon;
          }

          Axios.updateMaster(this.businessForm)
            .then((response) => {
              if (this.$refs.firstStep.model.fileList) {
                this.$refs.firstStep.submitUpload();
              }
              this.showHideLoading();
              this.forceRenderMenu();

              showContinue(
                this,
                response.data.message ? response.data.message : response.errors,
                '/businesses',
                null
              );
            })
            .catch((error) => this.showMessageErrors(error));
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      } else {
        if (this.isCreate()) {
          Axios.saveMaster(this.businessForm)
            .then((response) => {
              this.showHideLoading();
              this.forceRenderMenu();

              if (this.$refs.firstStep.model.fileList) {
                this.$refs.firstStep.uploadData.idBusiness =
                  response.data.data.id;
                this.$refs.firstStep.submitUpload();
              }
              showContinue(
                this,
                response.data.message ? response.data.message : response.errors,
                '/businesses',
                null
              );
            })
            .catch((error) => this.showMessageErrors(error));
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      }
    },
  },

  mounted() {
    this.selectedItemOnMenu('businesses');
  },

  beforeDestroy() {
    sessionStorage.removeItem('editForm');
    this.deselectedItemOnMenu('businesses');
  },
};
</script>
